import React from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

export const Faq = () => {
  const { CMS, backdrop } = useSelector((state) => state.auth, shallowEqual);
  return (
    <div className="faq_bx">
      <Accordion>
        {/* {CMS.FAQ && CMS.FAQ.FAQs
          ? CMS.FAQ.FAQs.map((faq, i) => (
              <Card key={faq._id}>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey={i}>
                    <i className="fas fa-caret-right"></i>
                    <span
                      className="faq_txt"
                      dangerouslySetInnerHTML={{
                        __html: faq.question,
                      }}
                    ></span>
                    <span className="mrbtn">MORE</span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey={i}>
                  <Card.Body
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  ></Card.Body>
                </Accordion.Collapse>
              </Card>
            ))
          : null} */}
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">
                Why shouldn’t I just use one of the more established
                Stablecoins?
              </span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              It all depends on what you are looking for. Most Stablecoins are
              based on shaky proof of value, or simply fiat currencies which
              themselves are subject to aspects such as inflation or
              devaluation. A gold-based Stablecoin offers the security of being
              back by a physical store of wealth in the form of gold that has
              been the preferred safe haven for thousands of years. However, not
              all gold-back stablecoins have been created as equal, and many
              cannot prove the amount (if any) of the gold, let alone have it
              independently certified. QRFID-GOLD was created to address all of
              those issues.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="1">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">What is ERC1400 standard?</span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              In layman’s terms, ERC1400 is an advanced version of and
              compatible with ERC20, built specifically to accelerate the
              issuance and management of securities on the Ethereum blockchain
              to allow more complex interactions. QRFID-GOLD Tokens allow a
              greater amount of information to be attached to it, so that more
              details can be recorded throughout the life of all the
              transactions that each Token undergoes. The benefit of this is to
              allow greater acceptance in terms of Compliance, an aspect that is
              inevitable and governments and financial institutions start to
              embrace cryptocurrency in general and start imposing regulatory
              requirements.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="2">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">
                What benefit do I have by buying these Tokens?
              </span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              Traditionally gold has been considered a niche investment as its
              safekeeping required an aspect of security often not available to
              the average person unless consisting of a certain size of
              investment. By buying QRFID-GOLD Tokens, anyone is able to possess
              even small amounts of physical gold without prohibitive costs
              whilst enjoying an extremely high level of security. The purpose
              of QRFID-Gold is to make the holding of physical investment-grade
              gold quick, easy, reliable and accessible to everyone whilst
              retaining the benefits of this time-tested security asset compared
              to fiat currencies.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="3">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">
                What proof is there that the gold in the vaults are not fake?
              </span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              The entire process, from the buying of the gold from verified and
              regulated gold dealers up until the issuance of the Tokens, is
              recorded and protocoled by the Swiss notary. For those wishing an
              added level of security for their investment in gold, QRFID-GOLD
              offers investors of 1kg or more their own safety deposit box which
              cannot be accessed without a member of QRFID-Management, the Swiss
              notary and the investor at the same time.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="4">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">
                Why shouldn’t I just buy real gold and keep it myself?
              </span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="4">
            <Card.Body>
              Keeping gold as an investment hedge is exactly what QRFID-GOLD is
              promoting. However, the ability to keep it secure for a reasonable
              fee, not to mention the relative expense of buying and selling
              through traditional dealers often does not make sense unless the
              investment amount is at least of a certain size. QRFID-GOLD Tokens
              allow users to buy and sell at the touch of a button by simply
              having access to a computer or a mobile, negating the need to
              securely transport gold to/from a dealer and pay for the
              subsequent testing of authenticity etc.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="5">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">
                How does QRFID-GOLD make its money?
              </span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="5">
            <Card.Body>
              <p>
                QRFID-GOLD is the sole emitter of the Tokens and charges a small
                percentage on each emission sale. As the price of Tokens rise,
                so do the gains of each emission sale, meaning that QRFID-GOLD is
                tied to the success of the Token sales.
              </p>
              <p>
                The ﬁrst step prior to the token issuance is the gold
                acquisition by QRFID-GOLD JSC from German or Swiss gold trading
                companies, each subject to the ﬁnancial regulatory authority of
                their respective country (BaFin or FinMa).
              </p>
              <p>
                Under notarial supervision and corresponding certiﬁcation, the
                gold is stored in the Swiss high-security bunker and irrevocably
                and unalterably identiﬁed using QRFID technology.
              </p>
              <p>
                Subsequently, the gold is digitized into QRFID tokens according
                to its value and made available for purchase by third parties.{" "}
              </p>
              <p>
                Accordingly a cost-covering service fee is charged by QRFID-GOLD
                JSC and settled with the token issue whose price is based on the
                respective international oﬃcial gold trading market price. The
                market price of the token will thereafter vary according to the
                demand and may be traded on the own QRFID-GOLD exchange or in the
                future on other participating exchanges.
              </p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="6">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">
                How do I withdraw my gold once I have bought Tokens?
              </span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="6">
            <Card.Body>
              Each user is able to access the physical gold (only if in
              possession of 100g or more) by initiating the process within the
              user’s own account on the QRFID-GOLD portal. Only once the User has
              completed the veriﬁcation process to prove their registered
              address to which the gold can be sent to, will the withdrawal
              process be ﬁnalised. Each withdrawal will be subject to delivery
              fees as well as administration and notarial charges as both
              QRFID-GOLD and the Swiss notary need to supervise and document the
              ‘burning’ of the representative Tokens to the main Ethereum Burn
              Wallet before being able to release the physical gold to the
              owner.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="7">
              <i className="fas fa-caret-right"></i>
              <span className="faq_txt">Can I see the gold in person?</span>
              <span className="mrbtn">MORE</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="7">
            <Card.Body>
              Yes, although due to the high security protocols you will be
              subjected to a vetting procedure. Once you access the vault you
              will be able to see yourself on the same live feed shown on the
              website.
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};
